export const exporterLeadsAutoJson = (apiLeads, LEAD_TASKS) =>
  apiLeads.map((lead) => ({
    ...lead,
    ...(Array.isArray(lead.tasks) && {
      tasks: lead.tasks.map((task) => ({
        ...task,
        nom: LEAD_TASKS.find((t) => t.id === task.nom)?.name || task.nom,
      })),
    }),
  }));
